export function isExternalUrl(href: string): boolean {
  return /^https?:\/\//.test(href);
}

export function opensInNewBrowserTab(href: string): boolean {
  return isExternalUrl(href) || href.startsWith("/api/studio/files/");
}
